import { readOnly } from 'models/restutil';

export class WeldingMachineDto {
  public static ApiUrl = 'api/welding-machines';

  Id: number;
  Manufacturer: string;
  MachineNumber: number;
  Model: string;
  CalibrationDate: Date;
  Note?: string;
  Active: boolean;
  Created?: Date;
  Updated?: Date;
  Deleted?: Date;
  @readOnly()
  IsDeleted: boolean;
}
